import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import CommunityList from './components/CommunityList';

import * as routes from './communities_apiRoutes';
import withSpinner from '../Common/utils/withSpinner';
import client from '../Common/utils/client';
import withAuth from '../Common/utils/withAuth';

const CommunityListWithSpinner = withSpinner(CommunityList);

class CommunitiesPage extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      communities: []
    };
  }

  componentDidMount() {
    this.setState({ loading: true });
    client
      .get(routes.COMMUNITY)
      .then(res => {
        let sorted = res.data.results.sort((a, b) =>
          a.name > b.name ? 1 : -1
        );
        if (sorted.length === 1) {
          localStorage.setItem('multiple', false);
          this.props.history.push('/community/' + sorted[0].uid);
        } else {
          localStorage.setItem('multiple', true);
          this.setState({
            communities: sorted,
            loading: false
          });
        }
      })
      .catch(error => {
        Sentry.captureException(error);
        if (error.response?.status === 401) {
          this.props.history.push('/login');
        } else {
          this.props.history.push('/');
        }
      });
  }
  render() {
    return (
      <CommunityListWithSpinner
        isLoading={this.state.loading}
        communities={this.state.communities}
        {...this.props}
      />
    );
  }
}

export default withAuth(CommunitiesPage);
